// ============ MAPA DOS ARQUÉTIPOS E CAPÍTULOS ============

export const mapaArquetiposCapitulos = {
  "Peregrino": {
    tipo: "raiz",
    posicao: { x: 50, y: 5 }, // Norte
    descricao_frio: "Sua estação do Movimento está mais silenciosa agora — talvez o coração esteja pedindo raiz antes de nova travessia.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 3 — Águas Cristalinas",
        parte: "Parte 2",
        bloco: "Bloco 4 — Ego, espiritualidade e humildade",
        razao: "O Peregrino descobre que o caminho espiritual é feito de passos simples e da entrega ao presente."
      },
      {
        capitulo: "Capítulo 4 — O Barco Vazio",
        parte: "Parte 2",
        bloco: "Bloco 8 — Travessia e permanência",
        razao: "A travessia silenciosa convida o Peregrino a encontrar movimento mesmo no silêncio."
      },
      {
        capitulo: "Capítulo 2 — O Limiar da Escolha",
        parte: "Parte 3",
        bloco: "Fábula — Você é forte (a borboleta e o casulo)",
        razao: "O Guerreiro e o Peregrino se encontram na coragem de escolher mesmo diante da incerteza."
      }
    ]
  },
  "Guardião": {
    tipo: "raiz",
    posicao: { x: 5, y: 50 }, // Oeste
    descricao_frio: "Sua estação do Corpo está mais suave — pode ser o momento de reconhecer que descansar também é caminhar.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 1 — Para você viver mais",
        parte: "Parte 2",
        bloco: "Bloco 1 — Silêncio e quietude",
        razao: "O Guardião vive no silêncio e na quietude. Este bloco ativa a estação do corpo e do descanso."
      },
      {
        capitulo: "Capítulo 5 — Aquele que permanece",
        parte: "Parte 2",
        bloco: "Bloco 9 — Presença e permanência",
        razao: "O domínio do Guardião: firmeza, propósito e o compromisso com o que permanece."
      },
      {
        capitulo: "Capítulo 4 — A Casa do Tempo",
        parte: "Parte 3",
        bloco: "Fábula — A lição da espera",
        razao: "A estação da pausa. O Guardião Sábio ensina a desacelerar e reconhecer o valor da permanência."
      }
    ]
  },
  "Amante": {
    tipo: "raiz",
    posicao: { x: 95, y: 50 }, // Leste
    descricao_frio: "Sua estação do Vínculo está quieta agora — não ausente, apenas esperando o tempo certo do encontro.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 3 — Águas Cristalinas",
        parte: "Parte 2",
        bloco: "Bloco 5 — Amor e relações",
        razao: "O Amante encontra sua força nos vínculos. Este bloco desperta a capacidade de conexão e afeto."
      },
      {
        capitulo: "Capítulo 1 — O Peso Insustentável do Ser",
        parte: "Parte 3",
        bloco: "Fecho Poético — O canto da fragilidade",
        razao: "O Poeta, o Curador e o Amante se encontram na vulnerabilidade que abre o coração."
      },
      {
        capitulo: "Capítulo 3 — O Coração Amanhece",
        parte: "Parte 3",
        bloco: "Fecho Poético — O eco das pequenas coisas",
        razao: "O Amante se reconhece nas pequenas presenças — este fecho poético ativa o sentido do vínculo."
      }
    ]
  },
  "Alquimista": {
    tipo: "raiz",
    posicao: { x: 50, y: 95 }, // Sul
    descricao_frio: "Sua estação do Sentido está em pausa — às vezes a dor precisa ser vivida antes de ser transformada.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 2 — A Perfeição Quando as Flores Caem",
        parte: "Parte 2",
        bloco: "Bloco 3 — Reflexões para dor, crises e crescimento",
        razao: "O domínio do Alquimista: transformar a dor em aprendizado, encontrar sentido no ciclo natural."
      },
      {
        capitulo: "Capítulo 5 — O Jardim do Perdão",
        parte: "Parte 3",
        bloco: "Fábula — O espelho da aurora (o cisne e a aurora)",
        razao: "O Alquimista revela o poder do perdão — o fogo que purifica e transmuta o coração."
      },
      {
        capitulo: "Capítulo 1 — Para você viver mais",
        parte: "Parte 2",
        bloco: "Bloco 2 — Sagrado e simples",
        razao: "O Alquimista encontra significado até nas coisas simples. Este bloco ativa a capacidade de ressignificar."
      }
    ]
  },
  "Visionário": {
    tipo: "dupla",
    raizes: ["Peregrino", "Alquimista"],
    posicao: { x: 30, y: 80 }, // Entre Peregrino e Alquimista
    descricao_frio: "Sua estação do Visionário está quieta — a intuição criadora aguarda o momento de se revelar.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 3 — Águas Cristalinas",
        parte: "Parte 2",
        bloco: "Bloco 4 — Ego, espiritualidade e humildade",
        razao: "O Visionário desperta quando a mente se abre para além do ego — este bloco integra o Peregrino e o Alquimista."
      },
      {
        capitulo: "Capítulo 6 — As Parábolas Gêmeas",
        parte: "Parte 2",
        bloco: "Bloco 11 — Além do certo e do errado",
        razao: "O Profeta, o Visionário e o Alquimista se encontram no ponto de virada entre certeza e mistério."
      },
      {
        capitulo: "Capítulo 6 — Lembre-se de Mim",
        parte: "Parte 3",
        bloco: "Fábula — O coração de todas as coisas",
        razao: "O Visionário encontra sua integração na última travessia — o retorno ao todo."
      }
    ]
  },
  "Peregrino do Encontro": {
    tipo: "dupla",
    raizes: ["Peregrino", "Amante"],
    posicao: { x: 75, y: 20 }, // Entre Peregrino e Amante
    descricao_frio: "Sua estação do Peregrino do Encontro está silenciosa — talvez a jornada precise, por ora, ser interior.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 3 — Águas Cristalinas",
        parte: "Parte 2",
        bloco: "Bloco 5 — Amor e relações",
        razao: "O Peregrino do Encontro floresce quando compreende que a caminhada é mais bela quando dividida."
      },
      {
        capitulo: "Capítulo 4 — O Barco Vazio",
        parte: "Parte 2",
        bloco: "Bloco 8 — Travessia e permanência",
        razao: "A travessia silenciosa convida o Peregrino do Encontro a reconhecer a presença dos que caminham junto."
      }
    ]
  },
  "Guerreiro": {
    tipo: "dupla",
    raizes: ["Guardião", "Alquimista"],
    posicao: { x: 20, y: 75 }, // Entre Guardião e Alquimista
    descricao_frio: "Sua estação do Guerreiro está em repouso — a força que não descansa acaba por quebrar.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 3 — Águas Cristalinas",
        parte: "Parte 2",
        bloco: "Bloco 6 — Autocuidado e limites",
        razao: "O Guerreiro precisa aprender que cuidar de si também é parte da luta — este bloco ativa a força com limites."
      },
      {
        capitulo: "Capítulo 2 — O Limiar da Escolha",
        parte: "Parte 3",
        bloco: "Fábula — Você é forte (a borboleta e o casulo)",
        razao: "O domínio do Guerreiro: a coragem de escolher e atravessar, mesmo diante do medo."
      },
      {
        capitulo: "Capítulo 5 — Aquele que Permanece",
        parte: "Parte 2",
        bloco: "Bloco 10 — Perseverança e raiz",
        razao: "O Guerreiro e o Guardião se encontram na perseverança enraizada — força que não quebra."
      }
    ]
  },
  "Curador": {
    tipo: "dupla",
    raizes: ["Guardião", "Amante"],
    posicao: { x: 25, y: 25 }, // Entre Guardião e Amante
    descricao_frio: "Sua estação do Curador está quieta — talvez seja hora de receber antes de oferecer.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 1 — O Peso Insustentável do Ser",
        parte: "Parte 3",
        bloco: "Fábula — A toupeira e o silêncio do luto",
        razao: "O domínio do Curador: o mergulho na dor, transformando sofrimento em acolhimento."
      },
      {
        capitulo: "Capítulo 3 — O Coração Amanhece",
        parte: "Parte 3",
        bloco: "Fecho Poético — O eco das pequenas coisas",
        razao: "O Curador integra dor e ternura — este fecho poético ativa o amanhecer do entendimento."
      },
      {
        capitulo: "Capítulo 1 — Para você viver mais",
        parte: "Parte 2",
        bloco: "Bloco 2 — Sagrado e simples",
        razao: "O Curador encontra força no simples — cuidar também é um gesto sagrado cotidiano."
      }
    ]
  },
  "Guardião Sábio": {
    tipo: "dupla",
    raizes: ["Guardião", "Alquimista"],
    posicao: { x: 15, y: 65 }, // Entre Guardião e Alquimista (profundidade)
    descricao_frio: "Sua estação do Guardião Sábio está em silêncio — estrutura e sentido ainda buscam se encontrar.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 1 — Para você viver mais",
        parte: "Parte 2",
        bloco: "Bloco 1 — Silêncio e quietude",
        razao: "O Guardião Sábio vive onde estrutura encontra sentido — o silêncio é o portal para essa integração."
      },
      {
        capitulo: "Capítulo 4 — A Casa do Tempo",
        parte: "Parte 3",
        bloco: "Fábula — A lição da espera",
        razao: "O domínio do Guardião Sábio: a estação da pausa, o valor da permanência e da espera consciente."
      },
      {
        capitulo: "Capítulo 3 — Águas Cristalinas",
        parte: "Parte 2",
        bloco: "Bloco 7 — Tempo, paciência e processo",
        razao: "O Guardião Sábio aprende que o tempo tem ritmo próprio — este bloco ativa a sabedoria do processo."
      }
    ]
  },
  "Poeta": {
    tipo: "dupla",
    raizes: ["Amante", "Alquimista"],
    posicao: { x: 80, y: 75 }, // Entre Amante e Alquimista
    descricao_frio: "Sua estação do Poeta está silenciosa — a expressão aguarda que a experiência se complete primeiro.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 2 — A Perfeição Quando as Flores Caem",
        parte: "Parte 2",
        bloco: "Bloco 3 — Reflexões para dor, crises e crescimento",
        razao: "O Poeta nasce da dor ressignificada — este bloco ativa a capacidade de transformar experiência em expressão."
      },
      {
        capitulo: "Capítulo 3 — O Coração Amanhece",
        parte: "Parte 3",
        bloco: "Fábula — A lição da coruja",
        razao: "O Poeta, o Guardião Sábio e o Amante se encontram na sabedoria que nasce do afeto e da observação."
      },
      {
        capitulo: "Capítulo 6 — Lembre-se de Mim",
        parte: "Parte 3",
        bloco: "Fábula — O coração de todas as coisas",
        razao: "O Poeta encontra sua voz mais plena na última travessia — onde expressão e visão se integram."
      }
    ]
  },
  "Profeta": {
    tipo: "tripla",
    raizes: ["Peregrino", "Amante", "Alquimista"],
    posicao: { x: 70, y: 60 }, // Convergência tripla
    descricao_frio: "Sua estação do Profeta está quieta — o chamado coletivo amadurece no silêncio interior.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 2 — A Perfeição Quando as Flores Caem",
        parte: "Parte 2",
        bloco: "Bloco 3 — Reflexões para dor, crises e crescimento",
        razao: "O Profeta nasce quando a dor se torna chamado coletivo — este bloco é o início dessa transformação."
      },
      {
        capitulo: "Capítulo 6 — As Parábolas Gêmeas",
        parte: "Parte 2",
        bloco: "Bloco 11 — Além do certo e do errado",
        razao: "O Profeta, o Visionário e o Alquimista se encontram no ponto de virada entre certeza e mistério."
      },
      {
        capitulo: "Capítulo 5 — O Jardim do Perdão",
        parte: "Parte 3",
        bloco: "Fecho Poético — O ponto da entrega",
        razao: "O Profeta encontra sua voz mais pura na rendição — quando o chamado não vem do ego, mas do coração."
      }
    ]
  },
  "Construtor": {
    tipo: "tripla",
    raizes: ["Peregrino", "Guardião", "Alquimista"],
    posicao: { x: 30, y: 55 }, // Convergência tripla
    descricao_frio: "Sua estação do Construtor está em pausa — talvez o que precisa ser construído ainda não tenha forma.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 3 — Águas Cristalinas",
        parte: "Parte 2",
        bloco: "Bloco 7 — Tempo, paciência e processo",
        razao: "O Construtor aprende que toda grande obra pede tempo — este bloco ativa a sabedoria do processo gradual."
      },
      {
        capitulo: "Capítulo 5 — Aquele que Permanece",
        parte: "Parte 2",
        bloco: "Bloco 10 — Perseverança e raiz",
        razao: "O Construtor e o Guerreiro se encontram na perseverança — a força que materializa o invisível."
      }
    ]
  },
  "Companheiro de Jornada": {
    tipo: "tripla",
    raizes: ["Peregrino", "Guardião", "Amante"],
    posicao: { x: 40, y: 30 }, // Convergência tripla
    descricao_frio: "Sua estação do Companheiro de Jornada está silenciosa — a lealdade descansa para poder se renovar.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 3 — Águas Cristalinas",
        parte: "Parte 2",
        bloco: "Bloco 5 — Amor e relações",
        razao: "O Companheiro de Jornada floresce na partilha — este bloco ativa o sentido da caminhada junto."
      },
      {
        capitulo: "Capítulo 5 — Aquele que Permanece",
        parte: "Parte 2",
        bloco: "Bloco 9 — Presença e permanência",
        razao: "O Companheiro de Jornada aprende que permanecer é também uma forma de cuidar — este bloco ativa a lealdade silenciosa."
      }
    ]
  },
  "Sábio Compassivo": {
    tipo: "tripla",
    raizes: ["Guardião", "Amante", "Alquimista"],
    posicao: { x: 55, y: 70 }, // Convergência tripla
    descricao_frio: "Sua estação do Sábio Compassivo está quieta — a compaixão enraizada aguarda seu momento de florescer.",
    quando_frio_recomendar: [
      {
        capitulo: "Capítulo 1 — Para você viver mais",
        parte: "Parte 2",
        bloco: "Bloco 1 — Silêncio e quietude",
        razao: "O Sábio Compassivo nasce do silêncio enraizado — este bloco ativa a compaixão que não se perde no outro."
      },
      {
        capitulo: "Capítulo 1 — O Peso Insustentável do Ser",
        parte: "Parte 3",
        bloco: "Fábula — A toupeira e o silêncio do luto",
        razao: "O Sábio Compassivo encontra sua integração no luto acolhido — amar sem se perder."
      },
      {
        capitulo: "Capítulo 6 — Lembre-se de Mim",
        parte: "Parte 3",
        bloco: "Fábula — O coração de todas as coisas",
        razao: "O Sábio Compassivo integra todas as experiências — esta fábula é o ápice da sabedoria encarnada em ternura."
      }
    ]
  },
  "Coração Inteiro": {
    tipo: "especial",
    posicao: { x: 50, y: 50 }, // Centro
    condicao: "diferença_entre_eixos_raiz <= 3",
    descricao: "Suas quatro estações estão caminhando juntas. Este é um momento de integração — não de chegada, mas de harmonia em movimento.",
    quando_recomendar: [
      {
        capitulo: "Capítulo 4 — O Barco Vazio",
        parte: "Parte 2",
        bloco: "Bloco 8 — Travessia e permanência",
        razao: "O Coração Inteiro representa o vazio fértil — o desapego do eu e a permanência da essência."
      },
      {
        capitulo: "Capítulo 6 — Lembre-se de Mim",
        parte: "Parte 3",
        bloco: "Fábula — O coração de todas as coisas",
        razao: "A última travessia. O Coração Inteiro integra todas as experiências, encerrando o ciclo com aceitação e amor."
      }
    ]
  }
};

// Mapeamento de nomes internos para nomes de exibição
export const arquetypeDisplayNames = {
  'peregrino': 'Peregrino',
  'guardiao': 'Guardião',
  'amante': 'Amante',
  'alquimista': 'Alquimista',
  'visionario': 'Visionário',
  'encontro': 'Peregrino do Encontro',
  'guerreiro': 'Guerreiro',
  'curador': 'Curador',
  'guardiao_sabio': 'Guardião Sábio',
  'poeta': 'Poeta',
  'profeta': 'Profeta',
  'construtor': 'Construtor',
  'companheiro': 'Companheiro de Jornada',
  'sabio_compassivo': 'Sábio Compassivo',
  'coracao_inteiro': 'Coração Inteiro'
};

// Threshold para estação fria (abaixo de 25/40)
export const COLD_SEASON_THRESHOLD = 25;

// Thresholds para combinações
export const DUAL_ACTIVE_THRESHOLD = 6;   // de 10
export const TRIPLE_ACTIVE_THRESHOLD = 12; // de 20

// Nomes dos eixos raiz
const ROOT_AXIS_NAMES = {
  peregrino: 'Peregrino',
  guardiao: 'Guardião',
  amante: 'Amante',
  alquimista: 'Alquimista'
};

// Nomes das estações para combinações
const DUAL_NAMES = {
  visionario: 'Visionário',
  encontro: 'Peregrino do Encontro',
  guerreiro: 'Guerreiro',
  curador: 'Curador',
  guardiao_sabio: 'Guardião Sábio',
  poeta: 'Poeta'
};

const TRIPLE_NAMES = {
  profeta: 'Profeta',
  construtor: 'Construtor',
  companheiro: 'Companheiro de Jornada',
  sabio_compassivo: 'Sábio Compassivo'
};

// Função para obter estações frias (raiz)
export const getColdSeasons = (mainArchetypes) => {
  const coldSeasons = [];
  Object.entries(mainArchetypes).forEach(([key, value]) => {
    if (value < COLD_SEASON_THRESHOLD && ROOT_AXIS_NAMES[key]) {
      coldSeasons.push({
        key,
        name: ROOT_AXIS_NAMES[key],
        score: value,
        data: mapaArquetiposCapitulos[ROOT_AXIS_NAMES[key]]
      });
    }
  });
  return coldSeasons;
};

// Função para obter estações quentes/ativas (raiz)
export const getHotSeasons = (mainArchetypes) => {
  const hotSeasons = [];
  Object.entries(mainArchetypes).forEach(([key, value]) => {
    if (value >= COLD_SEASON_THRESHOLD && ROOT_AXIS_NAMES[key]) {
      hotSeasons.push({
        key,
        name: ROOT_AXIS_NAMES[key],
        score: value
      });
    }
  });
  return hotSeasons.sort((a, b) => b.score - a.score);
};

// Função para classificar TODAS as estações (raiz + duplas + triplas)
export const classifyAllSeasons = (result) => {
  const { mainArchetypes, dominantArchetype, isCoracaoInteiro } = result;
  const dualCombinations = result.dualCombinations || {};
  const tripleCombinations = result.tripleCombinations || {};
  
  const active = [];
  const silent = [];
  
  // Classificar raízes
  Object.entries(mainArchetypes).forEach(([key, value]) => {
    const entry = {
      key,
      name: ROOT_AXIS_NAMES[key],
      score: value,
      maxScore: 40,
      tipo: 'raiz',
      isDominant: key === dominantArchetype
    };
    if (value >= COLD_SEASON_THRESHOLD) {
      active.push(entry);
    } else {
      silent.push(entry);
    }
  });
  
  // Classificar duplas
  Object.entries(dualCombinations).forEach(([key, value]) => {
    const entry = {
      key,
      name: DUAL_NAMES[key],
      score: value,
      maxScore: 10,
      tipo: 'dupla',
      isDominant: key === dominantArchetype
    };
    if (value >= DUAL_ACTIVE_THRESHOLD) {
      active.push(entry);
    } else {
      silent.push(entry);
    }
  });
  
  // Classificar triplas
  Object.entries(tripleCombinations).forEach(([key, value]) => {
    const entry = {
      key,
      name: TRIPLE_NAMES[key],
      score: value,
      maxScore: 20,
      tipo: 'tripla',
      isDominant: key === dominantArchetype
    };
    if (value >= TRIPLE_ACTIVE_THRESHOLD) {
      active.push(entry);
    } else {
      silent.push(entry);
    }
  });
  
  // Ordenar: dominante primeiro, depois por score descendente
  active.sort((a, b) => (b.isDominant ? 1 : 0) - (a.isDominant ? 1 : 0) || b.score - a.score);
  silent.sort((a, b) => a.score - b.score);
  
  return { active, silent, isCoracaoInteiro };
};

// Função para obter capítulos recomendados (LEGADO - mantido para compatibilidade)
export const getRecommendedChapters = (result) => {
  const deep = getDeepRecommendations(result);
  // Flatten para formato simples
  const chapters = [];
  const seen = new Set();
  deep.forEach(group => {
    group.chapters.forEach(ch => {
      const key = ch.capitulo + ch.bloco;
      if (!seen.has(key)) {
        seen.add(key);
        chapters.push({ ...ch, fromSeason: group.eixoName });
      }
    });
  });
  return chapters.slice(0, 3);
};

// ====== MOTOR DE RECOMENDAÇÕES PROFUNDAS ======
// Orientado por tensões, sombras e negligências — não por leituras soltas
import { calculateDynamics } from './tensionData';

const ROOT_KEY_TO_NAME = {
  peregrino: 'Peregrino',
  guardiao: 'Guardião',
  amante: 'Amante',
  alquimista: 'Alquimista'
};

// Frases de direção para cada eixo silenciado
const direcaoAtencao = {
  peregrino: {
    icone: 'O Movimento pede passagem',
    convite: 'Seu coração precisa de espaço para explorar, mudar e se renovar. O Peregrino é a estação que nos lembra: nem sempre ficar é a resposta.'
  },
  guardiao: {
    icone: 'O Corpo pede presença',
    convite: 'Seu coração precisa de raiz, estrutura e descanso. O Guardião é a estação que nos lembra: cuidar de si é o primeiro ato de amor.'
  },
  amante: {
    icone: 'O Vínculo pede entrega',
    convite: 'Seu coração precisa de conexão, presença e vulnerabilidade. O Amante é a estação que nos lembra: viver é ser tocado pelo outro.'
  },
  alquimista: {
    icone: 'O Sentido pede profundidade',
    convite: 'Seu coração precisa de reflexão, transformação e significado. O Alquimista é a estação que nos lembra: a dor que não vira sabedoria vira repetição.'
  }
};

export const getDeepRecommendations = (result) => {
  const { mainArchetypes, isCoracaoInteiro, dominantArchetype } = result;
  
  // Coração Inteiro: recomendação especial de manutenção
  if (isCoracaoInteiro || dominantArchetype === 'coracao_inteiro') {
    const coracaoData = mapaArquetiposCapitulos['Coração Inteiro'];
    if (coracaoData?.quando_recomendar) {
      return [{
        eixo: 'coracao_inteiro',
        eixoName: 'Coração Inteiro',
        direcao: 'Sustentação do equilíbrio',
        convite: 'Suas estações coexistem em harmonia. O convite agora é sustentar essa integração — não como conquista, mas como prática viva.',
        fonte: 'equilibrio',
        chapters: coracaoData.quando_recomendar
      }];
    }
  }
  
  const dynamics = calculateDynamics(result);
  const recommendations = [];
  const eixosCobertos = new Set();
  
  // 1. TENSÕES → identificar o eixo SOMBREADO (o que precisa de atenção)
  dynamics.tensions.forEach(tension => {
    const shadowedKey = tension.shadowed.key;
    if (eixosCobertos.has(shadowedKey)) return;
    eixosCobertos.add(shadowedKey);
    
    const shadowedName = ROOT_KEY_TO_NAME[shadowedKey];
    const dominantName = tension.dominant.name;
    const direcao = direcaoAtencao[shadowedKey];
    const chaptersData = mapaArquetiposCapitulos[shadowedName];
    
    if (chaptersData?.quando_frio_recomendar) {
      recommendations.push({
        eixo: shadowedKey,
        eixoName: shadowedName,
        direcao: direcao?.icone || `${shadowedName} precisa de atenção`,
        convite: direcao?.convite || '',
        motivo: `Seu ${dominantName} forte projeta uma sombra sobre o ${shadowedName}. Todo excesso denuncia uma falta — e estes capítulos despertam exatamente o que está silencioso.`,
        fonte: 'tensao',
        tensionId: tension.id,
        intensidade: tension.intensity,
        chapters: chaptersData.quando_frio_recomendar.slice(0, 2)
      });
    }
  });
  
  // 2. TRIPLAS ATIVAS → identificar o eixo NEGLIGENCIADO
  dynamics.tripleReadings
    .filter(t => t.status === 'ativo' && t.neglectedAxis)
    .forEach(triple => {
      const neglectedKey = triple.neglectedAxis.key;
      if (eixosCobertos.has(neglectedKey)) return;
      eixosCobertos.add(neglectedKey);
      
      const neglectedName = ROOT_KEY_TO_NAME[neglectedKey];
      const direcao = direcaoAtencao[neglectedKey];
      const chaptersData = mapaArquetiposCapitulos[neglectedName];
      
      if (chaptersData?.quando_frio_recomendar) {
        recommendations.push({
          eixo: neglectedKey,
          eixoName: neglectedName,
          direcao: direcao?.icone || `${neglectedName} precisa de atenção`,
          convite: direcao?.convite || '',
          motivo: `Sua convergência tripla (${triple.name}) ativa três estações com força — mas negligencia o ${neglectedName}. O equilíbrio pede que essa estação também seja ouvida.`,
          fonte: 'tripla',
          chapters: chaptersData.quando_frio_recomendar.slice(0, 2)
        });
      }
    });
  
  // 3. ESTAÇÕES FRIAS restantes (que não foram cobertas por tensões/triplas)
  const coldSeasons = getColdSeasons(mainArchetypes);
  coldSeasons.forEach(season => {
    if (eixosCobertos.has(season.key)) return;
    eixosCobertos.add(season.key);
    
    const direcao = direcaoAtencao[season.key];
    
    if (season.data?.quando_frio_recomendar) {
      recommendations.push({
        eixo: season.key,
        eixoName: season.name,
        direcao: direcao?.icone || `${season.name} precisa de atenção`,
        convite: direcao?.convite || '',
        motivo: `O ${season.name} está silencioso no seu mapa. Estes capítulos ajudam a despertar essa estação.`,
        fonte: 'fria',
        chapters: season.data.quando_frio_recomendar.slice(0, 2)
      });
    }
  });
  
  // Limitar a 3 grupos de recomendação
  return recommendations.slice(0, 3);
};

// Função para obter o nome de exibição do arquétipo
export const getArchetypeDisplayName = (key) => {
  return arquetypeDisplayNames[key] || key;
};
